import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../Auth"
import { LeadReportsList } from "../../Leads"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { generatePath } from "../../router-utils"

export default function LeadsReport() {
	return (
		<>
			<Helmet>
				<title>Leads Report</title>
			</Helmet>
			<Breadcrumbs
				title="Leads Report"
				items={[
					[generatePath("/trip-plan-requests"), "Leads"],
					["", "Reports"],
				]}
			/>
			<ForbidUnlessAuthorized
				permission={PERMISSIONS.MANAGE_TRIP_PLAN_REQUESTS}
			>
				<LeadReportsList />
			</ForbidUnlessAuthorized>
		</>
	)
}
